import tools from './tools'
import isValid from './isValid'
import {Message} from 'iview'
import router from '../router'


//获取token的方法
const getToken = () => {
    if(isValid.isExp()){
      let token = tools.getSession('token');
      return token;
    }else{
      window.timeOut = 1;
      return false;
    }
}

/**
 * ajax  请求后状态处理
 * @param data object 请求后返回的数据   
 * @param off  boolean 参数的状态值    
 * @param fn  function 回调函数    
 * @param fn1  function 失败时回调函数    
 * @param show  boolean 是否弹框    
 */
const ajaxMsg = (data,off,fn,fn1,show) =>{
  off = (off=== true? true: false)
  show = (show === false? false: true)
  if(data.code == 0 && off === true && show === true){
      console.log('data',data)
    Message.error({
      content:data.message,
      onClose: fn1?()=>{fn1()}:function(){}
    })
    return false
  }
  if(data.code == 1 && off === true && show === true){
    Message.success({
      content:data.message,
      onClose: fn?()=>{fn()}:function(){}
    })
    return true
  }
  if(data.code == 3){
    window.refreshToken = 2;
    sessionStorage.clear();
    router.push({name:data.data.url});
    return;
  }

  if(fn && show === false){
    fn()
  }

}

/**
 * 通用消息框
 * @param type string 消息类型
 * @param content string 消息内容
 * @param fn function 回调
 * 
 */
const msg = (type,content,fn) => {
  Message[type]({
    content:content,
    onClose: fn?()=>{fn()}:function(){}
  })
}

/**
 * 数组去重
 * @param arr Array 合并后的数组
 */
const unData = (arr) =>{
  var map={};
  if(arr&&Array.isArray(arr)){
      for(var i=arr.length;i>=0;--i){
          if(arr[i] in map){
              arr.splice(arr[i],1);
          }else{
              map[arr[i]] = true;
          }
      }
  }
  return arr;
}

let transPrice = (price) => {
	if(price == '' || price == 0){
		return 0
	}else{
		return price = Number((price/100).toFixed(3))
	}
}
export default {
  getToken,
  ajaxMsg,
  msg,
  unData,
  transPrice
}
